angular.module('memberPortal').controller('MembershipPlansCtrl', ["$scope", "$state", "$stateParams", "$filter", "DataService", "membershipPlans", function($scope, $state, $stateParams, $filter, DataService, membershipPlans) {
  $scope.data = DataService;
  $scope.membershipPlans = membershipPlans.filter(function(plan) {
    return !plan.specified_start_date || moment(plan.specified_start_date).isSameOrAfter(moment(), 'day');
  });
  $scope.currency = DataService.currency;
  if (!DataService.member_details.can_purchase_memberships) {
    $state.go('memberPortal.bookings', {
      m: $scope.getHash()
    });
  }
  $scope.getHash = function() {
    return $stateParams.hash || $stateParams.m;
  };
  return $scope.displayStartDate = function(plan) {
    var ref;
    return plan.specified_start_date || ((ref = plan.default_start_date_strategy) === 'start_on_next_upcoming' || ref === 'start_relative_to_purchase_date');
  };
}]);
